import React, {Component} from 'react';
import './profile.scss'
import {UserDto} from "../../../../Models/UserDto";
import {Form, Icon, Input, Button, message } from 'antd';
// import {userService} from "../../../../Services/User.Service";
import axios from "axios";
// import {TicketStatusDto} from "../../../../Models/TicketStatusDto";
const formItemLayout = {
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
    },
};
 class profile extends Component <any, any>{
  state={
    user:new UserDto(),
    loading: false,
    confirmDirty: false,
    autoCompleteResult: [],
  };
  componentDidMount() {
    let user:any=localStorage.getItem('UserData');
    let userInformation=JSON.parse(user);
    this.setState({ user: userInformation });
    this.props.form.setFieldsValue(userInformation)
}

  handleSubmit = (e:any) => {
    e.preventDefault();
    this.props.form.validateFields((err:any, values:any )=> {
      if (!err) {
        console.log('Received values of form: ', values);
        this.setState({  loading: true });

          axios
              .put(`https://8i9s27h4vl.execute-api.us-west-2.amazonaws.com/dev/merchant/`,values)
              .then((response :any)=> {
                  this.setState({  loading: false });

                  this.setState({  loading: true });

                  axios
                      .get(`${'https://8i9s27h4vl.execute-api.us-west-2.amazonaws.com/dev/'}merchant?group=${'brand'}&email=${values.Email}`)

                      .then(profile => {
                          this.setState({  loading: false });



                          if (profile) {




                              localStorage.setItem('UserData', JSON.stringify(profile.data));

                              this.setState({ user: profile.data });
                              this.props.form.setFieldsValue(profile.data)

                          }

                      })
                      .catch(error => {
                          this.setState({  loading: false });
                      });


                  message.success(' Your information has been successfully modified. ');


              })
              .catch(error => {
                  this.setState({  loading: false });
                  // message.error(error);
              });

      }
    });
  };


  handleConfirmBlur =(e:any) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  compareToFirstPassword = (rule:any, value:any, callback:any) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('Password')) {
      callback(' The passwords you entered are not the same!');
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule:any, value:any, callback:any) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  render() {
    const {loading} = this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <div className="page-account">
      <div className="row">
        <Form  {...formItemLayout} onSubmit={this.handleSubmit} className="page-profile"  >
            <div className="row">
                <div className="col-md-6">
                    <Form.Item>
                        {getFieldDecorator('firstname', {
                            rules: [{ required: true, message: 'Please enter your first name !' }],
                        })(
                            <Input
                                name="firstname"
                                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                placeholder="FirstName"
                            />,
                        )}
                    </Form.Item>
                </div>
                <div className="col-md-6">
                    <Form.Item>
                        {getFieldDecorator('lastname', {
                            rules: [{ required: true, message: 'Please enter your last name !' }],
                        })(
                            <Input
                                name="lastname"
                                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                placeholder="LastName"
                            />,
                        )}
                    </Form.Item>
                </div>
                <div className="col-md-6">
                    <Form.Item >
                        {getFieldDecorator('phonenumber', {
                            rules: [{ required: false, message: 'Please enter your mobile number!' }],
                        })(<Input
                            name="phonenumber"
                            prefix={<Icon type="mobile" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            placeholder="Mobile"
                            style={{ width: '100%' }} />)}
                    </Form.Item>
                </div>

                <div className="col-md-6">
                    <Form.Item >
                        {getFieldDecorator('email', {
                            rules: [
                                {
                                    type: 'email',
                                    message: 'Invalid email!',
                                },
                                {
                                    required: true,
                                    message: 'please enter your Email!',
                                },
                            ],
                        })(<Input
                            readOnly
                            disabled
                            name="email"
                            prefix={<Icon type="tag" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            placeholder="Email"
                        />,)}
                    </Form.Item>
                </div>
                {/*<div className="col-md-6">*/}

                    {/*<Form.Item >*/}
                        {/*{getFieldDecorator('Username', {*/}
                            {/*rules: [{ required: true, message: 'Please enter your username!' }],*/}
                        {/*})(*/}
                            {/*<Input*/}
                                {/*readOnly*/}
                                {/*disabled*/}
                                {/*prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}*/}
                                {/*placeholder="Username"*/}
                            {/*/>,*/}
                        {/*)}*/}
                    {/*</Form.Item>*/}
                {/*</div>*/}
                {/*<div className="col-md-6">*/}
                    {/*<Form.Item >*/}
                        {/*{getFieldDecorator('Password', {*/}
                            {/*rules: [*/}
                                {/*{*/}
                                    {/*min: 6,*/}
                                    {/*message: 'حداقل 6 کاراکتر باید داشته باشد',*/}
                                {/*},*/}
                                {/*{ required: true,  message: 'لطفا رمز عبور خود را وارد کنید !' },*/}
                                {/*{*/}
                                    {/*validator: this.validateToNextPassword,*/}
                                {/*},*/}
                            {/*],*/}
                        {/*})(*/}
                            {/*<Input.Password*/}
                                {/*prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}*/}
                                {/*type="password"*/}
                                {/*placeholder="پسوورد"*/}
                            {/*/>,*/}
                        {/*)}*/}
                    {/*</Form.Item>*/}
                {/*</div>*/}
                {/*<div className="col-md-6">*/}
                    {/*<Form.Item >*/}
                        {/*{getFieldDecorator('RePassword', {*/}
                            {/*rules: [*/}

                                {/*{*/}
                                    {/*required: true,*/}
                                    {/*message: 'لطفا رمز خود را تأیید کنید!',*/}
                                {/*},*/}
                                {/*{*/}
                                    {/*validator: this.compareToFirstPassword,*/}
                                {/*},*/}
                            {/*],*/}
                        {/*})(<Input.Password*/}
                            {/*prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}*/}
                            {/*type="password"*/}
                            {/*placeholder="تکرار رمز عبور"*/}
                            {/*onBlur={this.handleConfirmBlur} />)}*/}
                    {/*</Form.Item>*/}
                {/*</div>*/}

                <div className="col-md-6">
                    <Button type="primary" block  loading={loading} onClick={this.handleSubmit} >
                        Submit
                    </Button>
                </div>
            </div>








        </Form>

      </div>
      </div>
    )
  }
}
export default Form.create<any>({
  // ...
})(profile);


